import React from "react"
import Form from "./Form" // Path to your reusable Form component
import { submitToHubSpot } from "../../utils/submitToHubSpot"
import * as styles from "./FormsStyles/FooterForm.module.css"

const FooterForm = () => {
  const portalId = "46102677" // Replace with your HubSpot Portal ID
  const formId = "b5bc3188-9006-4d3d-9c86-60dc514816a1" // Replace with your HubSpot Form ID

  const fields = [
    { label: "First Name", name: "firstname", required: true, placeholder: true },
    { label: "Last Name", name: "lastname", required: true, placeholder: true },
    { label: "Company Name", name: "company", required: true, placeholder: true },
    { label: "Job Title", name: "jobtitle", required: true, placeholder: true },
    { label: "Email", name: "email", required: true, placeholder: true },
  ]

  const handleSubmit = async data => {
    const fieldsToSubmit = Object.entries(data).map(([name, value]) => ({
      name,
      value,
    }))
    await submitToHubSpot(fieldsToSubmit, portalId, formId)
  }

  return (
    <div className="w-100 text-end">
      <div className="home-form">
        <div className="home-form-content text-end">
          <Form
            fields={fields}
            handleSubmit={handleSubmit}
            className={`${styles.footerForm} footer-form`}
            submitButtonLabel="Submit"
          />
        </div>
      </div>
    </div>
  )
}

export default FooterForm
